import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FeatureFlagOverride, writeOverride } from 'shared/feature-flags/feature-flag-storage';
import { FeatureFlagName } from 'shared/feature-flags/flags';

/** Параметр-переключалка флоу: `?flow=v2` включает новый флоу, `?flow=v1` — возвращает старый. */
export const FLOW_QUERY_PARAM = 'flow';

const FLOW_FLAG: FeatureFlagName = 'applicationsFlowV2';

const FLOW_VALUES: Record<string, FeatureFlagOverride> = {
  v2: 'on',
  v1: 'off',
};

/**
 * Переключение флоу ссылкой: `?flow=v2` в любом адресе приложения пишет override
 * в localStorage и стирается из строки адреса, чтобы не путаться в закладках и шарингах.
 *
 * Вызывается один раз — в `main-layout.tsx`, поэтому работает на любом экране под шеллом.
 * Неизвестное значение параметра игнорируется и остаётся в адресе: чужой `?flow=` не наш.
 */
export const useFeatureFlagQueryParam = (): void => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const raw = params.get(FLOW_QUERY_PARAM);

    if (!raw) {
      return;
    }

    const override = FLOW_VALUES[raw];

    if (!override) {
      return;
    }

    writeOverride(FLOW_FLAG, override);
    params.delete(FLOW_QUERY_PARAM);

    const search = params.toString();

    navigate({ pathname: location.pathname, search: search ? `?${search}` : '', hash: location.hash }, { replace: true });
  }, [location.pathname, location.search, location.hash, navigate]);
};
